export default function Router(routes) {

    var router = {
        url: function (routeName, params) {
            let url;
            let route = _.find(routes, function (_route) { return _route.name == routeName; });

            if (route) {
                url = route.url;

                if (params) {
                    url = url.replace(/\{(\w+)\??\}/g, (match, param) => {
                        if (param in params) {
                            const paramValue = params[param];
                            delete params[param];
                            return paramValue ? paramValue.toString() : '';
                        } else {
                            return '';
                        }
                    });

                    if (!_.isEmpty(params)) {
                        url += "?" + _$.param(params);
                    }
                }
            }

            let protocol = URI().protocol();

            if (!_.includes(url, protocol)) {
                url = protocol + '://' + url;
            }

            return url;
        }
    };

    return router;
}



// WEBPACK FOOTER //
// ./resources/js/components/Helpers/Router.js